import { Formatter } from "../../../types/formatConfigTypes";
import { InputType } from "../../../types/inputTypes";

export const pieChartFormatters: Formatter[] = [
    {
        key: 'label',
        label: 'Label',
        inputType: InputType.TEXT,
        applyFormatter(value, { labels, index }) {
            labels[index] = value;
        }
    },
    {
        key: 'backgroundColor',
        label: 'Background Color',
        inputType: InputType.COLOR,
        applyFormatter(value, { dataset, index }) {
            dataset.backgroundColor[index] = value;
        }
    },
    {
        key: 'borderColor',
        label: 'Border Color',
        inputType: InputType.COLOR,
        applyFormatter(value, { dataset, index }) {
            if (dataset.borderColor == null) {
                dataset.borderColor = new Array(index);
            }
            dataset.borderColor.push(value);
        }
    }
];
